/**
 * @generated SignedSource<<839182179249cf08c7640ef98391e847>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FirmDetailsWrapper_photoNode$data = {
  readonly firmName: string | null;
  readonly firmProfileIcon: string | null;
  readonly firmUrlLabel: string | null;
  readonly photo: {
    readonly caption: string | null;
  } | null;
  readonly projectName: string | null;
  readonly projectUrl: string | null;
  readonly " $fragmentType": "FirmDetailsWrapper_photoNode";
};
export type FirmDetailsWrapper_photoNode$key = {
  readonly " $data"?: FirmDetailsWrapper_photoNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"FirmDetailsWrapper_photoNode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FirmDetailsWrapper_photoNode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firmName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firmUrlLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firmProfileIcon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhoto",
      "kind": "LinkedField",
      "name": "photo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "caption",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradePhotosQueryOutput",
  "abstractKey": null
};

(node as any).hash = "76dc17f189df11ba006b5f4a1d3a21c8";

export default node;
